import makeApi from './api';

export default async function fetchArticle(conditionId: string, articleId: string) {
  const api = makeApi();
  const response = await api.get(
    `/api/v1/web_chat/v3.0/help-center/knowledgebase/${conditionId}/entries/${articleId}/`
  );
  return response.data;
}
